<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Dodawanie uprawnienia"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="savePermission"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-select placeholder="Wybierz uprawnienie..." :model="$schema.permissionId" :values="permissions" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/permissionRelation.schema';

const emptyData = () => ({
  permissionId: null,
  roleId: null
});

// @vuese
// Modal dodania uprawnienia
// @group Modals
export default {
  name: 'PermissionRelationModal',
  mixins: [manageMixin('role/permission', {}, emptyData)],
  schema,
  computed: mapState({
    permissions: state =>
      state.permission.list
        .filter(perm => !state.role.permission.list.some(rolePerm => rolePerm.permission.id === perm.id))
        .map(perm => ({ value: perm.id, text: perm.name }))
  }),
  methods: {
    // @vuese
    // Zapisywanie uprawnienia
    savePermission() {
      this.$schema.roleId.$model = parseInt(this.$route.params.roleId);
      this.save();
    }
  }
};
</script>
